import { User } from '@legacy-types';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { useToast } from '@shared/ui/components/Toast';
import { disableTwoFactorAuthentication } from '@shared/users/endpoints/disableTwoFactorAuthentication';

type DisableTwoFactorAuthenticationButtonProps = {
  user: User;
  onDisable?: (user: User) => void;
};

export function DisableTwoFactorAuthenticationButton({ user, onDisable }: DisableTwoFactorAuthenticationButtonProps) {
  const { toast } = useToast();

  function handleDisable() {
    disableTwoFactorAuthentication(user).then(() => {
      if (onDisable) {
        onDisable(user);
      }
    });

    toast({
      title: 'Disabled',
      description: 'Two factor authentication disabled.',
    });
  }

  const canDisable = user.twoFactorEnabled;

  return (
    <Button variant="destructive" onClick={handleDisable} disabled={!canDisable}>
      <Icon icon="trash" /> Disable 2FA
    </Button>
  );
}
